"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WORKLOG_TYPE_CODES = exports.VALID_TIME_RANGE = void 0;
exports.VALID_TIME_RANGE = 0.116; //  7 Minutes
exports.WORKLOG_TYPE_CODES = {
    travel: 1210,
};
